import * as React from 'react';
import { styled } from '@mui/material/styles';
import Popper from '@mui/material/Popper';
import { autocompleteClasses } from '@mui/material/Autocomplete';
import ButtonBase from '@mui/material/ButtonBase';
import InputBase from '@mui/material/InputBase';

interface PopperComponentProps {
	anchorEl?: any;
	disablePortal?: boolean;
	open: boolean;
}

const StyledAutocompletePopper = styled('div')(({ theme }) => ({
	[`& .${autocompleteClasses.paper}`]: {
		boxShadow: 'none',
		margin: 0,
		color: 'inherit',
		fontSize: 13,
	},
	[`& .${autocompleteClasses.listbox}`]: {
		backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1c2128',
		padding: 0,
		[`& .${autocompleteClasses.option}`]: {
			minHeight: 'auto',
			alignItems: 'flex-start',
			padding: 8,
			borderBottom: `1px solid  ${
				theme.palette.mode === 'light' ? ' #eaecef' : '#30363d'
			}`,
			'&[aria-selected="true"]': {
				backgroundColor: 'transparent',
			},
			[`&.${autocompleteClasses.focused}, &.${autocompleteClasses.focused}[aria-selected="true"]`]:
				{
					backgroundColor: theme.palette.action.hover,
				},
		},
	},
	[`&.${autocompleteClasses.popperDisablePortal}`]: {
		position: 'relative',
	},
}));

export function PopperComponent(props: PopperComponentProps) {
	const { disablePortal, anchorEl, open, ...other } = props;
	return <StyledAutocompletePopper {...other} />;
}

export const StyledPopper = styled(Popper)(({ theme }) => ({
	border: `1px solid ${
		theme.palette.mode === 'light' ? '#e1e4e8' : '#30363d'
	}`,
	boxShadow: `0 8px 24px ${
		theme.palette.mode === 'light'
			? 'rgba(149, 157, 165, 0.2)'
			: 'rgb(1, 4, 9)'
	}`,
	borderRadius: 6,
	width: 300,
	zIndex: theme.zIndex.modal,
	fontSize: 13,
	color: theme.palette.mode === 'light' ? '#24292e' : '#c9d1d9',
	backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1c2128',
}));

export const StyledInput = styled(InputBase)(({ theme }) => ({
	padding: 10,
	width: '100%',
	borderBottom: `1px solid ${
		theme.palette.mode === 'light' ? '#eaecef' : '#30363d'
	}`,
	'& input': {
		borderRadius: 4,
		backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#0d1117',
		padding: 8,
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		border: `1px solid ${
			theme.palette.mode === 'light' ? '#eaecef' : '#30363d'
		}`,
		fontSize: 14,
		'&:focus': {
			boxShadow: `0px 0px 0px 3px ${
				theme.palette.mode === 'light'
					? 'rgba(3, 102, 214, 0.3)'
					: 'rgb(12, 45, 107)'
			}`,
			borderColor: theme.palette.mode === 'light' ? '#0366d6' : '#388bfd',
		},
	},
}));

export const StyledButton = styled(ButtonBase)(({ theme }) => ({
	fontSize: 13,
	// width: '100%',
	textAlign: 'left',
	paddingBottom: 8,
	color: theme.palette.mode === 'light' ? '#586069' : '#8b949e',
	fontWeight: 600,
	'&:hover,&:focus': {
		color: theme.palette.mode === 'light' ? '#0366d6' : '#58a6ff',
	},
	'& span': {
		width: '100%',
	},
	'& svg': {
		width: 16,
		height: 16,
	},
}));
